import request from '@/utils/request'

// 获取备案配置信息
export function recordsConfig(params: any) {
    return request.get(
        { url: '/Config/detail', params },
        { ignoreCancelToken: true }
    )
}

// 修改备案配置信息
export function editConfig(params: any) {
    return request.post({ url: '/config/edit', params })
}

// 获取基础代码
export function getBaseCode(params: any) {
    return request.get(
        {
            url: '/config/getBaseCode',
            params
        },
        { ignoreCancelToken: true }
    )
}
// 获取枚举数据
export function getEnum(params: any) {
    return request.get(
        {
            url: '/config/getEnum',
            params
        },
        { ignoreCancelToken: true }
    )
}

// 获取服务内容
export function getAppServiceCode(params: any) {
    return request.get(
        {
            url: '/config/getAppServiceCode',
            params
        },
        { ignoreCancelToken: true }
    )
}
